// extracted by mini-css-extract-plugin
export var acitonButtons = "_ma-0";
export var additionalIcon = "_ma-f";
export var block = "_ma-1";
export var blockContent = "_ma-7";
export var blockDescription = "_ma-8";
export var blockIcon = "_ma-9";
export var blockTitle = "_ma-6";
export var border = "_ma-a";
export var center = "_ma-l";
export var edge = "_ma-b";
export var edgeLabel = "_ma-c";
export var edgePath = "_ma-d";
export var error = "_ma-e";
export var flowchart = "_ma-g";
export var flowchartContent = "_ma-h";
export var highlighted = "_ma-3";
export var hover = "_ma-4";
export var icon = "_ma-i";
export var left = "_ma-m";
export var navButton = "_ma-j";
export var navButtons = "_ma-k";
export var right = "_ma-n";
export var selected = "_ma-2";
export var small = "_ma-5";